"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var sis_simple_combo_settings_component_1 = require("./sis-simple-combo-settings.component");
var sis_control_with_settings_1 = require("../../sis-control-with-settings");
require("./sis-simple-combo.component.scss");
var SisSimpleCombo = /** @class */ (function (_super) {
    __extends(SisSimpleCombo, _super);
    function SisSimpleCombo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.placeholderKey = 'de_select_one';
        _this.onChange = new core_1.EventEmitter();
        return _this;
    }
    SisSimpleCombo.prototype.isRemoveActive = function () {
        return this.value;
    };
    SisSimpleCombo.prototype.delete = function (event) {
        this.value = null;
        event.stopPropagation();
        this.onChange.emit(this.value);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], SisSimpleCombo.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisSimpleCombo.prototype, "value", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], SisSimpleCombo.prototype, "placeholderKey", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], SisSimpleCombo.prototype, "onChange", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], SisSimpleCombo.prototype, "items", void 0);
    SisSimpleCombo = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Simple combo',
            settings: {
                main: sis_simple_combo_settings_component_1.SisSimpleComboSettingsComponent,
            },
            cellCount: 3,
            template: "\n                        <sis-simple-combo [id]=\"'%{id}'\" [value]=\"%{field}\"[hint]=\"%{hint}\"\n                        (onChange)=\"%{onChange}\"\n                        [items]=\"%{items}\"\n                         %{#placeholderKey} [placeholderKey]=\"%{placeholderKey}\"%{/placeholderKey}>\n                        </sis-simple-combo>\n                     ",
            isFieldBound: true,
            defaultActions: {
                'items': 'loadClassifiers',
                'onChange': 'onClassifierChange'
            }
        }),
        core_1.Component({
            selector: 'sis-simple-combo',
            template: require('./sis-simple-combo.component.html'),
        })
    ], SisSimpleCombo);
    return SisSimpleCombo;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisSimpleCombo = SisSimpleCombo;
//# sourceMappingURL=sis-simple-combo.component.js.map